import React, { Component, useRef } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import mapStateToProps from "../../../store/mapStateToProps";
import mapDispatchToProps from "../../../store/mapDispatchToProps";
import { hit } from "../../metrics";
import CaseFooter from "../CaseFooter";
import HelmetSite from "../HelmetSite";
import "./style.css";
import Parallax from "parallax-js";
import simpleParallax from "simple-parallax-js";

class Rep extends Component {
  state = {
    preview: true,
  };

  handleScroll() {
    $(".animate-scroll-element").each(function () {
      const top = $(this).offset().top - window.innerHeight / 2;
      const scr = $(window).scrollTop();

      if (scr >= top) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    });
  }

  componentDidMount() {
    var video = document.getElementById("video-vrb");
    $(".but-vrb").click(function () {
      $(".but-vrb").toggleClass("min");
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
    var image = document.getElementsByClassName("");
    new simpleParallax(image, {
      scale: 1.5,
    });

    $(".kms-block6").hover(function () {
      $(".iner1").removeClass("iner-active1");
      $(".iner2").removeClass("iner-active2");
      $(".iner3").removeClass("iner-active3");
      $(".iner4").removeClass("iner-active4");
      $(".iner6").removeClass("iner-active6");
      $(this).css("left", "16%");
    });

    $(window).on("mousemove", function (e) {
      var w = $(window).width();
      var h = $(window).height();
      var offsetX = 0.5 - e.pageX / w;
      var offsetY = 0.5 - e.pageY / h;

      $(".parallax").each(function (i, el) {
        var offset = parseInt($(el).data("offset"));
        var translate =
          "translate3d(" +
          Math.round(offsetX * offset) +
          "px," +
          Math.round(offsetY * offset) +
          "px, 0px)";

        $(el).css({
          "-webkit-transform": translate,
          transform: translate,
          "moz-transform": translate,
        });
      });
    });

    if (this.props.pathname == "/projects/vrb/") {
      this.setState({ preview: false });
      this.props.setProjectName("bsg");
      $("body").addClass("case-expanded hash-vrb");
      $(window).scrollTop($(".vsn").offset().top);
      this.props.changeCase(null);
    } else {
      this.setState({ preview: true });
      $("body").removeClass("vrb");
    }
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    setTimeout(() => {
      $("body").addClass("fadepage");
    }, 100);

    window.addEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    if (this.props.pathname == "/projects/") {
      $("body").removeClass("case-expanded hash-vrb");
    }
  }

  componentWillUnmount() {
    $("body").removeClass("fadepage");
    window.removeEventListener("scroll", this.handleScroll);
    if (window.parallaxInstance) {
      window.parallaxInstance.disable();
    }
  }

  render() {
    return (
      <div className="case rep">
        <div className="case-content " ref={(el) => (this.scene = el)}>
          <div className="rep-head">
            <img className="rep-img1" src="/cases/img/rep/1.webp"></img>
            <img className="rep-img2" src="/cases/img/rep/2.svg"></img>
          </div>
          <div className="rep-block1">
            <div className=" vrb-bubble1 text text1 bubble right parallax-front parallax-up active">
              <div className="in">
                Сайт интерпретирует
                <br /> концепцию посёлка:
                <br /> лаконичность, перетекание <br /> пространств, гармонию
                <br /> с природой
              </div>
            </div>
            <img className="rep-img3 shadow" src="/cases/img/rep/3.webp"></img>
          </div>
          <div className="rep-block2">
          <div className=" rem-vrb-bubble2 vrb-bubble3 text text1 bubble right-bottom  parallax-front parallax-up active">
              <div className="in">
              При разработке дизайна сайта был проведен редизайн логотипа. В результате посёлок избавился от тяжёлого знака идущего в разрез с основной концепцией: лаконичностью. Вдохновение мы нашли 
в выдающихся карнизах зданий, являющихся наследнием стиля Фрэнка Ллойда Райта
              </div>
            </div>
            <img className="rep-img4 shadow" src="/cases/img/rep/4.webp"></img>
            <div className="rep-wrap">
              <img className="rep-img5" src="/cases/img/rep/5.svg"></img>
              <img className="rep-img6" src="/cases/img/rep/6.svg"></img>
              <img className="rep-img7" src="/cases/img/rep/7.svg"></img>
            </div>
          </div>
          <div className="rep-block3">
          <div className=" rem-bublle3 vrb-bubble1 text text1 bubble left parallax-front parallax-up active">
              <div className="in">
              Должно быть столько же стилей домов, сколько существует разных<br/>людей. Человек, который обладает индивидуальностью, имеет право<br/> на свое выражение в его собственной среде.<br/>
              <p></p> 
                <br/>
          
Фрэнк Ллойд Райт
              </div>
            </div>
            <img className="rep-img8 " src="/cases/img/rep/8.webp"></img>
          </div>
          <div className="rep-block4">
            <img className="rep-img9 " src="/cases/img/rep/9.webp"></img>
          </div>
          <div className="rep-block5">
            <img className="rep-img10 shadow" src="/cases/img/rep/10.webp"></img>
            <img className="rep-img11 shadow" src="/cases/img/rep/11.webp"></img>
            <img className="rep-img12 shadow" src="/cases/img/rep/12.webp"></img>
          </div>
          <div className="rep-block6">
            <img className="rep-img13 shadow" src="/cases/img/rep/13.webp"></img>
          </div>
          <div className="vrb-block8">
            <div className=" vrb-bubble4 text text1 bubble right-top  parallax-front parallax-up active">
              <div className="in">Видео–демонстрация работы сайта</div>
            </div>
            <div
              className="video-brb"
              style={{ backgroundImage: `url('/cases/img/vrb/img14.png')` }}
            >
              <div className="video-in-vrb">
                <div
                  className="but-vrb rep-but"
                  style={{ backgroundImage: `url('/cases/img/vrb/img16.svg')` }}
                ></div>
                <video
                  id="video-vrb"
                  poster="/cases/img/rep/14.webp"
                  loop
                  preload="metadata"
                >
                  <source
                    src="/cases/img/rep/video.mp4"
                    type="video/mp4"
                  ></source>
                </video>
              </div>
            </div>
          </div>
          <div className="vrb-block9">
            <div className=" vrb-bubble5 text text1 bubble left  parallax-front parallax-up active">
              <div className="in">
                Так выглядит сайт в смартфоне. Адаптация происходит под любое
                устройство
              </div>
            </div>

            <div className="vrb-block9-flex">
              <img
                className="rep-img17 shadow"
                src="/cases/img/rep/16.webp"
              ></img>
              <div className="vrb-img9-in">
                <img
                  className="vrb-img18 shadow"
                  src="/cases/img/rep/17.webp"
                ></img>
                <img
                  className="vrb-img21 shadow"
                  src="/cases/img/rep/18.webp"
                ></img>
              </div>
              <img
                className="vrb-img20 shadow"
                src="/cases/img/rep/19.webp"
              ></img>
            </div>
          </div>
        </div>

  

      <CaseFooter 
				to={ this.props.next ? this.props.next.url: "/projects/ahead/"  }
				title= { this.props.next ? this.props.next.name: "Ahead"  } 
				img={ this.props.next ? this.props.next.imgCaseBottom:"/cases/img/next/ahead_next.webp"}
			/>
        <HelmetSite title={`Клубный поселок «Репинское»`} />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rep);
